import { SvgEventHandlers } from "./types"
import * as d3 from "d3"
import { ButtonDatum } from "app/core/components/dashboard/d3/types"
import * as params from "app/core/components/dashboard/d3/params"
import * as clipboard from "app/core/components/dashboard/d3/clipboard"
import * as screen from "app/core/components/dashboard/d3/screen"
import * as button from "app/core/components/dashboard/d3/button"

export const register = (handlers?: SvgEventHandlers, editable?: boolean): (() => void) => {
  const keyHandler = async (event: KeyboardEvent) => {
    const domHasChanged = await onKeyDown(event)
    handlers?.key?.(domHasChanged, event)
  }
  if (editable) {
    document.addEventListener("keydown", keyHandler)
    return () => {
      document.removeEventListener("keydown", keyHandler)
    }
  }
  return () => {}
}

export const onKeyDown = async (event: KeyboardEvent): Promise<boolean> => {
  if (event.key === "Meta") {
    return false
  }
  const selectedButtonElements = d3
    .select<SVGGElement, ButtonDatum>("#svg-dashboard")
    .selectAll("g.playerdash-dashboard-button.selected")
  const horizontalStep = (event.shiftKey ? params.fastMoveFactor : 1) * params.horizontalResolution
  const verticalStep = (event.shiftKey ? params.fastMoveFactor : 1) * params.verticalResolution
  switch (event.key) {
    case "ArrowUp":
      selectedButtonElements.datum((datum: ButtonDatum) => ({
        ...datum,
        y: screen.constrainY(datum.y - verticalStep, datum.height),
      }))
      button.updatePosition(selectedButtonElements)
      event.preventDefault()
      return true
    case "ArrowRight":
      selectedButtonElements.datum((datum: ButtonDatum) => ({
        ...datum,
        x: screen.constrainX(datum.x + horizontalStep, datum.width),
      }))
      button.updatePosition(selectedButtonElements)
      event.preventDefault()
      return true
    case "ArrowDown":
      selectedButtonElements.datum((datum: ButtonDatum) => ({
        ...datum,
        y: screen.constrainY(datum.y + verticalStep, datum.height),
      }))
      button.updatePosition(selectedButtonElements)
      event.preventDefault()
      return true
    case "ArrowLeft":
      selectedButtonElements.datum((datum: ButtonDatum) => ({
        ...datum,
        x: screen.constrainX(datum.x - horizontalStep, datum.width),
      }))
      button.updatePosition(selectedButtonElements)
      event.preventDefault()
      return true
    case "c":
      if (event.metaKey) {
        if (clipboard.copy()) {
          event.preventDefault()
        }
      }
      return false
    case "x":
      if (event.metaKey) {
        if (clipboard.cut()) {
          event.preventDefault()
          return true
        }
      }
      return false
    case "d":
      if (event.metaKey) {
        if (clipboard.duplicate()) {
          event.preventDefault()
          return true
        }
      }
      return false
    case "v":
      // deal with this in the "paste" handler,
      // which is the only place where we can reliably access the clipboard
      return false
  }
  return false
}
